import { LoginBox } from '@components/Login/LoginPanel';
import { useAuthContext } from '@repo/hooks';
import { LoginToClay, OAuthView } from '@views/Auth/OauthLogin/views';
import React, { useCallback, useEffect, useState } from 'react';
import styles from '@views/Auth/OauthLogin/views/OauthLoginViews.module.scss';
import apiKeyStyles from './ApiKeys.module.scss';
import cn from 'classnames';
import { LoginButton } from '@repo/components/buttons';
import clayLogo from '@app/img/login/logos/clay.svg';
import { LoaderIcon } from '@repo/icons';
import { apiRequest } from '@repo/utils/helpers/api';

export default function ApiKeys() {
  const { user } = useAuthContext();
  const [userNeedsToLogin, setUserNeedsToLogin] = useState(false);
  const [apiKey, setApiKey] = useState<string | null>(null);
  const [isCreatingApiKey, setIsCreatingApiKey] = useState(false);

  const handleCreateApiKey = useCallback(() => {
    setIsCreatingApiKey(true);

    const expire = new Date();
    expire.setFullYear(expire.getFullYear() + 1);

    apiRequest<{ key: string }>(
      'POST',
      '/api-keys/',
      { expiry_date: expire.toISOString() },
      { apiVersion: 'v2' },
    )
      .then((res) => {
        console.log(res);
        setApiKey(res.key);
      })
      .finally(() => {
        setIsCreatingApiKey(false);
      });
  }, []);

  useEffect(() => {
    if (!user) {
      setUserNeedsToLogin(true);
    }
  }, []);

  if (userNeedsToLogin) {
    return <LoginToClay integration="apikey" />;
  }

  return (
    <OAuthView>
      <LoginBox className={cn(styles.box, styles.withBtns)}>
        <div className={styles.integrationGraphicContainer}>
          <img src={clayLogo} alt="Clay Logo" className={styles.logo} />
        </div>
        <div className={styles.headline}>Create API Key</div>
        <div className={styles.message}>
          Create an API key to access Clay. This will allow you to make API requests to Clay's
          endpoints.
        </div>

        {apiKey ? (
          <>
            <input className={cn('form-input', apiKeyStyles.apiKeyInput)} value={apiKey} readOnly />
            <button
              className={cn(styles.cancelBtn, styles.btn)}
              onClick={() => (location.href = '/')}
            >
              Close
            </button>
          </>
        ) : (
          <>
            <LoginButton
              disabled={isCreatingApiKey}
              onClick={handleCreateApiKey}
              className={cn(styles.allowBtn, styles.btn)}
            >
              {isCreatingApiKey ? (
                <LoaderIcon customColor="#fff" width="18" height="18" r="1" />
              ) : (
                'Create API Key'
              )}
            </LoginButton>
            <button
              className={cn(styles.cancelBtn, styles.btn)}
              onClick={() => (location.href = '/')}
            >
              Cancel
            </button>
          </>
        )}
      </LoginBox>
    </OAuthView>
  );
}
